import { message, Tooltip } from 'm-ui';
import React from 'react';
import { switchAccount, systemLogout } from 'utils/login';
import { withLog, switchLoginClickLog, logoutClickLog } from 'utils/businesslog';
import './dropMenu.less';

export interface DropdownMenuProps {
    userName: string;
    userId: number;
    account?: {
        accountId: string;
        accountName: string;
    };
}

export function DropdownMenu(props: DropdownMenuProps) {
    function handleCopyAccountId() {
        const input = document.getElementById('user-id-clipboard') as HTMLInputElement;
        input.select();
        document.execCommand('Copy'); // 执行浏览器复制命令
        message.success('已成功复制ID到剪切板');
    }

    const switchAccountHandler = withLog(switchLoginClickLog, switchAccount);
    const logoutHandler = withLog(logoutClickLog, systemLogout);

    return (
        <div className="drop-info">
            <div className="user-info block">
                <div className="style-bold">快手名：{props.userName}</div>
                <If condition={props.userId}>
                    <div className="style-desc">快手ID：{props.userId}</div>
                </If>
            </div>
            {props.account && (
                <div className="account-info block">
                    <div className="style-desc">当前登入的广告账号：</div>
                    <div className="t">
                        <Tooltip overlayStyle={{ zIndex: 3000 }} title={props.account.accountName}>
                            <span>{props.account.accountName}</span>
                        </Tooltip>
                        <a onClick={switchAccountHandler}>切换</a>
                    </div>
                    <div className="t">
                        <span>ID：{props.account.accountId}</span>
                        <a onClick={handleCopyAccountId}>复制</a>
                    </div>
                    <input readOnly id="user-id-clipboard" value={props.account.accountId} />
                </div>
            )}
            <div className="login-out block" onClick={logoutHandler}>
                退出登录
            </div>
        </div>
    );
}
